


export default function Contact() {
    return (
        <div>
        <img src="https://pianolangpic.s3.us-east-2.amazonaws.com/contact.png" className="img-fluid w-100" alt="Contact information" />
        </div>
    );
    }